(function($) {
    // 2depth tab navi
    $( window ).scroll(function( e ) {
        var $window = $( window ),
            $body = $( 'body' ),
            $navi = $( '.depth2List' );
        scrollTop = $window.scrollTop() || document.documentElement.scrollTop;

        if ( scrollTop > 180 ) {
            $navi.addClass( 'depth2_fixed' );
        } else {
            $navi.removeClass( 'depth2_fixed' );
        }
    });

    $(document).ready(function(){
        $('#lnb').remove();
        $(window).on('load resize scroll',function(){
            var $this = $(this),
                $h = $this.height(),
                $top = $this.scrollTop(),
                $btn_top = $('.quickbar').offset().top,
                $v = 400-$top-($h/2);
            if($v <= 0){
                setTimeout(function(){
                    $('.quickbar').stop().animate({'top':($top-5)+($h/2)},100);
                },30)
            }
        });

        $(document).on('click', 'a.btn_top', function(e){
            e.preventDefault();
            var $b = $(this).attr('href').split('#')[1];
            $('html, body').stop().animate({scrollTop:0},200)
        });

        // quickbar (2depth)
        $(".depth2List > ul").clone().prependTo(".quickbar");
    });
})(jQuery);


//logout관련
function GNBLogout() {
    var frm = document.getElementById("FrmGNBLogout");
    frm.submit();
}


// WEBPACK FOOTER //
// ./src/js/epatch.js